import { LoginType } from "../models/enum/login";
import { LoginForm } from "../components/login/loginForm";
import { twclsx } from "../utils/cssUtil";
import { FaneventTitle } from "../components/common/faneventTitle";
import { useTranslation } from "react-i18next";
import { useAtom } from "jotai";
import { loginTypeAtom } from "../atoms/loginAtom";

export function Login() {
  const [loginType, setLoginType] = useAtom<LoginType>(loginTypeAtom);
  const onChangeLoginType = (loginType: LoginType) => {
    setLoginType(loginType);
  };
  const { t } = useTranslation();

  return (
    <>
      <div className={"flex flex-col items-center gap-3"}>
        <div className={"h-20 flex-auto"}></div>
        <div className={"wev-logo"}></div>
        <FaneventTitle />
        <div role={"tablist"} className={"tabs tabs-boxed bg-base-200"}>
          <label
            role={"tab"}
            className={twclsx(
              "tab",
              loginType === LoginType.WEAUTH && "tab-active",
            )}
            onClick={() => {
              onChangeLoginType(LoginType.WEAUTH);
            }}
          >
            {t("logingate_tab1")}
          </label>
          <label
            role={"tab"}
            className={twclsx(
              "tab",
              loginType !== LoginType.WEAUTH && "tab-active",
            )}
            onClick={() => {
              onChangeLoginType(LoginType.ONE_DAY_STAFF);
            }}
          >
            {t("logingate_tab2")}
          </label>
        </div>
        <LoginForm type={loginType} />
      </div>
    </>
  );
}
